module.exports = __webpack_public_path__ + "static/img/salimova.5a11723.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/salimova.jpg
// module id = 499
// module chunks = 11